// src/helpers/ukPlayerTypes.js
export const hasPlayerType = (clubs, playerType) => {
    // TODO: Replace with actual player type detection logic
    // For now, return true to enable all buttons during development
    return clubs.length > 0;
};